import React from 'react';

export default function FAQ({setShowingApp}: {setShowingApp: any}) {
    function clickNariBunny(){
        setShowingApp('nari-comment');
    }
    return (
        <section id="faq" className="u-p-2">
            <h1>FAQ</h1>
            <div className="question-item u-pt-2">
                <h3>✿ Why always Hinata-centric? ✿</h3>
                <p>
                    I like her and I think she is perfect for a number of pairings.
                </p>
            </div>
            <div className="question-item u-pt-1">
                <h3>✿ How do I write so much? ✿</h3>
                <p>
                    A little at a time, I write daily no matter how little, and a few years of practice.
                </p>
            </div>
            <div className="question-item u-pt-1">
                <h3>✿ Any writing advice? ✿</h3>
                <p>
                    Take a look at my
                    <a className="navigation__link-social"
                      href="https://www.tumblr.com/lavender-long-stories/735564277998616576/writing-advice-getting-words-on-a-page">
                    Writing Advice: Getting Words on a Page</a>
                    post and my
                    <a className="navigation__link-social"
                       href="https://www.tumblr.com/lavender-long-stories/770945724331458560/i-wrote-1-million-works-in-2024">1
                        Million Words Q&A</a> post
                </p>
            </div>
            <div className="question-item u-pt-1">
                <h3>✿ Do you accept fan art? ✿</h3>
                <p>Yes! Here is some of the fan art made for me in the past: </p>

                <ul className="navigation__list">
                    <li className="navigation__item d-block u-pb-2">
                        <a className="navigation__link-social"
                           href="https://www.tumblr.com/kersu/717940044454903808/disabled-besties-au?source=share">
                            Disabled Besties AU Comic
                        </a>
                        for
                        <a className="navigation__link-social" href="https://archiveofourown.org/works/46451539">
                            Wheels
                        </a>
                        by
                        <a className="navigation__link-social" href="https://www.tumblr.com/kersu">
                            @kersu
                        </a>
                    </li>
                    <li className="navigation__item d-block u-pb-1">
                        <a className="navigation__link-social"
                           href="https://www.tumblr.com/stephsageek/725051143487717376/heres-some-fun-fan-art-i-made-for">
                            Hinata and Kisame Fan Art
                        </a>
                        for
                        <a className="navigation__link-social" href="https://archiveofourown.org/works/46750711">
                            Lavender Umbrellas
                        </a>
                        by
                        <a className="navigation__link-social" href="https://stephsageek.tumblr.com/">
                            @stephsageek
                        </a>
                    </li>
                    <li className="navigation__item d-block u-pb-1">
                        <a className="navigation__link-social"
                           href="https://www.tumblr.com/0rent/727033185560625152/this-is-a-drawing-i-did-of-samehada-the-cat-from">
                            Samehade the Cat
                        </a>
                        for
                        <a className="navigation__link-social" href="https://archiveofourown.org/works/46750711">
                            Lavender Umbrellas
                        </a>
                        by
                        <a className="navigation__link-social" href="https://0rent.tumblr.com/">
                            @Orent
                        </a>
                    </li>
                    <li className="navigation__item d-block u-pb-2">
                        <a className="navigation__link-social"
                           href="https://www.tumblr.com/stephsageek/727318657418625024/for-lavender-long-stories-incredible-story">
                            Akatsuki Hinata
                        </a>
                        for
                        <a className="navigation__link-social" href="https://archiveofourown.org/works/46538125">
                            Lavender Clouds
                        </a>
                        by
                        <a className="navigation__link-social" href="https://stephsageek.tumblr.com/">
                            @stephsageek
                        </a>
                    </li>
                    <li className="navigation__item d-block u-pb-1">
                        <a className="navigation__link-social"
                           href="https://www.tumblr.com/nikandrros/718042113942732800/death-wishes-by-lavender-long-stories-ao3-and">
                            Cover
                        </a>
                        for
                        <a className="navigation__link-social" href="https://archiveofourown.org/works/46750087">
                            Death Wishes
                        </a>
                        by
                        <a className="navigation__link-social" href="https://nikandrros.tumblr.com/">
                            @nikandrros
                        </a>

                        <img onClick={clickNariBunny} alt='bun' className="nari-secret-image" src="/images/rabbit.png" width="16" height="16"/>
                    </li>
                    <li className="navigation__item d-block u-pb-1">
                        <a className="navigation__link-social"
                           href="https://www.tumblr.com/nikandrros/721507259410219008/testing-success-by-lavender-long-stories-ao3">
                            Cover
                        </a>
                        for
                        <a className="navigation__link-social" href="https://archiveofourown.org/works/46472983">
                            Testing Success
                        </a>
                        by
                        <a className="navigation__link-social" href="https://nikandrros.tumblr.com/">
                            @nikandrros
                        </a>
                    </li>
                    <li className="navigation__item d-block u-pb-1">
                        <a className="navigation__link-social"
                           href="https://www.tumblr.com/nikandrros/725005095395278848/lavender-letters-by-lavender-long-stories-ao3">
                            Cover
                        </a>
                        for
                        <a className="navigation__link-social" href="https://archiveofourown.org/works/49167538">
                            Lavender Letters
                        </a>
                        by
                        <a className="navigation__link-social" href="https://nikandrros.tumblr.com/">
                            @nikandrros
                        </a>
                    </li>
                    <li className="navigation__item d-block u-pb-1">
                        <a className="navigation__link-social"
                           href="https://www.tumblr.com/nikandrros/721221596188147713/lavender-clouds-by-lavender-long-stories-ao3">
                            Cover
                        </a>
                        for
                        <a className="navigation__link-social" href="https://archiveofourown.org/works/46538125">
                            Lavender Clouds
                        </a>
                        by
                        <a className="navigation__link-social" href="https://nikandrros.tumblr.com/">
                            @nikandrros
                        </a>
                    </li>
                    <li className="navigation__item d-block u-pb-1">
                        <a className="navigation__link-social"
                           href="https://www.tumblr.com/nikandrros/726769647857369088/i-will-love-you-by-lavender-long-stories-ao3">
                            Cover
                        </a>
                        for
                        <a className="navigation__link-social" href="https://archiveofourown.org/works/48255163">
                            I Will Love You
                        </a>
                        by
                        <a className="navigation__link-social" href="https://nikandrros.tumblr.com/">
                            @nikandrros
                        </a>
                    </li>
                </ul>

            </div>
        </section>

    )
}